import React, { useMemo } from 'react';
import { contains } from '@/utils';
import { useStore } from '@/stores';
import { Tooltip } from 'antd';

interface AccessProps {
  permission: string[]; // 匹配的权限字符串
  fallback?: React.ReactNode; // 无权限时的显示，默认无权限不显示任何内容
  allowShow?: boolean; //true为无权限置灰
  children?: any;
}

const AccessButton: React.FC<AccessProps> = (props) => {
  const { permission, children } = props;
  const userStore = useStore('user');

  const accessible = useMemo(() => {
    return contains(userStore.info?.permissions || [], permission);
  }, [permission, userStore?.info?.permissions]);

  if (props.allowShow) {
    return <>{accessible ? children : React.cloneElement(children as any, { disabled: true })}</>;
  }

  // 如果是本地local环境，显示权限名称，方便调试
  if (process.env.NODE_ENV === 'development') {
    return <>{accessible ? <Tooltip title={permission.join(', ')}>{children}</Tooltip> : null}</>;
  }
  return <>{accessible ? children : null}</>;
};
export default AccessButton;
